import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const SupportedDevicesSeoStrategy = createSimplePageStrategy(
  'supportedDevices',
  'supported-devices',
  '/esim-compatible-devices'
);
